import { CalculationSettingsModel, RNAVModel } from './configuration';
import { NavaidDTOCalculation } from './navaid';

export class PerformanceDTO {
  flightLevel : number;
  calculationType : number;
  minAltitude: number;
  maxAltitude: number;
  altitudeInterval: number;
  navaids: NavaidDTOCalculation[] = [];
  name:string;
  calculationSettings: CalculationSettingsModel;
  rnav: RNAVModel;
  isNSE : boolean;
  isRedundancy : boolean;
  isAvailablePairs : boolean;
  isSubtendedAngles : boolean;
  supressOverlapingPolygons : boolean;
  projectId: number;
  isDMEDME: boolean = true;
}

export class PerformanceDTOModel {
  name:string;
  flightLevel : number;
  flightLevelMeters : number;
  minAltitude: number;
  minAltitudeMeters: number;
  maxAltitude: number;
  maxAltitudeMeters: number;
  altitudeInterval: number;
  altitudeIntervalMeters: number;
  isSingleLevel : boolean = false;
  navaids: NavaidDTOCalculation[] = [];
  calculationType : number;
  isSupressOverlappingPolygons  : boolean = true;
  isSimplifyPolygons : boolean = true;

  isRedundancy : boolean;
  isSubtendedAngles : boolean;
  isNSE : boolean;
  isAvailablePairs : boolean;



  constructor(){
    this.isSingleLevel = false;
  }

}
